import React, { useEffect } from 'react';

export const MobPdfViewer = props => {
  const { hostUrl } = props;
  useEffect(() => {
    window.history.go(-2);
    window.open(hostUrl, 'Popup' + new Date().getTime());
  }, [hostUrl]);

  return <></>;
};
